var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-icon',{attrs:{"size":"xs","color":_vm.value ? 'green' : 'red',"name":_vm.value ? 'check_circle':'close'}})}
var staticRenderFns = []

export { render, staticRenderFns }